/**
 * Fast Bundle modern PDP enhancements (SBAP widgets).
 * Loaded only when modern PDP styling is on AND the template is not solo-saunas.
 * - Repositions the widget below Shop Pay / payment_terms
 * - Syncs the bundle running total into [data-solo-sauna-price] when present
 */

(function () {
  if (document.body.classList.contains('template-product-solo-saunas')) return;

  function formatMoney(cents) {
    const format =
      window.theme?.moneyFormat ||
      (typeof Shopify !== 'undefined' && Shopify.money_format) ||
      '${{amount}}';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updatePrice(section, variant) {
    const priceHost = section.querySelector('[data-solo-sauna-price]');
    if (!priceHost || !variant) return;

    const saleEl = priceHost.querySelector('sale-price');
    const compareEl = priceHost.querySelector('compare-at-price');
    const hasCompare =
      variant.compare_at_price != null &&
      variant.compare_at_price > variant.price;

    if (saleEl) {
      const lastChild = saleEl.lastChild;
      if (lastChild) {
        lastChild.replaceWith(
          document.createRange().createContextualFragment(formatMoney(variant.price))
        );
      }
      // Only force sale styling when we know compare-at from the widget.
      // Otherwise leave Liquid's sale/compare classes alone (BAP products).
      if (variant.compare_at_price != null) {
        saleEl.classList.toggle('text-on-sale', hasCompare);
        saleEl.classList.toggle('bold', hasCompare);
      }
    } else {
      const fallback = priceHost.querySelector('.text-on-sale, .text-lg, .price-list');
      if (fallback) fallback.textContent = formatMoney(variant.price);
    }

    // Only touch compare-at when Fast Bundle provides a real higher raw total.
    // If the widget has no compare/raw price, keep Shopify's Liquid compare-at.
    if (compareEl && variant.compare_at_price != null) {
      if (hasCompare) {
        const lastChild = compareEl.lastChild;
        if (lastChild) {
          lastChild.replaceWith(
            document.createRange().createContextualFragment(
              formatMoney(variant.compare_at_price)
            )
          );
        }
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    const cleaned = String(text).replace(/[^\d.,]/g, '').replace(/,/g, '');
    if (!cleaned) return null;
    const value = parseFloat(cleaned);
    if (Number.isNaN(value)) return null;
    return Math.round(value * 100);
  }

  function initFastBundle(section) {
    function syncFromBundle(container) {
      const saleNode = container.querySelector(
        '.rbr-total-box-price .money, .rbr-total-box-price'
      );
      const rawNode = container.querySelector(
        '.rbr-total-box-rawPrice .money, .rbr-total-box-rawPrice'
      );
      const saleCents = parseMoneyToCents(saleNode && saleNode.textContent);
      if (saleCents == null) return;

      const rawCents = parseMoneyToCents(rawNode && rawNode.textContent);
      // Pass compare only when FB exposes a higher raw/compare total.
      // Undefined compare leaves the theme's Shopify compare-at untouched
      // (needed for Fast Bundle BAP products that already have compare-at set).
      const payload = { price: saleCents };
      if (rawCents != null && rawCents > saleCents) {
        payload.compare_at_price = rawCents;
      }
      updatePrice(section, payload);
    }

    function moveBundleBelowPaymentTerms(container) {
      // Fast Bundle mounts inside <payment-terms>, pushing Shop Pay below it.
      // Move the widget to sit after payment-terms: price → installments → bundle.
      const paymentTerms =
        container.closest('payment-terms.product-info__payment-terms') ||
        container.closest('payment-terms');
      if (!paymentTerms || !paymentTerms.parentNode) return;
      paymentTerms.parentNode.insertBefore(container, paymentTerms.nextSibling);

      if (paymentTerms.dataset.fbBundleRepositionBound === 'true') return;
      paymentTerms.dataset.fbBundleRepositionBound = 'true';
      new MutationObserver(() => {
        if (container.parentElement === paymentTerms) {
          paymentTerms.parentNode.insertBefore(container, paymentTerms.nextSibling);
        }
      }).observe(paymentTerms, { childList: true });
    }

    function wire(container) {
      if (container.dataset.fbBundleWired === 'true') return;
      container.dataset.fbBundleWired = 'true';

      moveBundleBelowPaymentTerms(container);
      syncFromBundle(container);

      new MutationObserver(() => syncFromBundle(container)).observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      container.addEventListener('change', (event) => {
        if (event.target && event.target.tagName === 'SELECT') {
          window.setTimeout(() => syncFromBundle(container), 50);
          window.setTimeout(() => syncFromBundle(container), 300);
        }
      });
    }

    function tryWire() {
      const container = section.querySelector('#rbr-container-element-true');
      if (!container || !container.children.length) return false;
      wire(container);
      return true;
    }

    if (tryWire()) return;

    let attempts = 0;
    const poll = window.setInterval(() => {
      attempts += 1;
      if (tryWire() || attempts > 40) window.clearInterval(poll);
    }, 250);
  }

  function init() {
    document.querySelectorAll('.shopify-section--main-product').forEach((section) => {
      if (!section.querySelector('.solo-sauna-pdp')) return;
      initFastBundle(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (
      event.target.classList.contains('shopify-section--main-product') &&
      event.target.querySelector('.solo-sauna-pdp')
    ) {
      initFastBundle(event.target);
    }
  });
})();
